<div class="logo">
  <img src="assets/img/fleetoperate-logo.png" />
</div>

<div class="title">Unsubscription <span class="failure">Unsuccessful </span></div>

<p fxFlex>
  There was a problem and we were not able to remove you from your mailing list. <br><br> Please contact us at <a href="mailto:{{contactEmail}}">{{contactEmail}}</a>
</p>

<div>
  Follow us<br><br>
  <a href="{{facebookURL}}"><img src="assets/img/facebook.png" class="social-media-imgs" /></a>
  <a href="{{twitterURL}}"><img src="assets/img/twitter.png" class="social-media-imgs" /></a>
  <a href="{{linkedInURL}}"><img src="assets/img/linkedin.png" class="social-media-imgs" /></a>
</div>

<div class="copyright">
  <hr> <br>
  <span>&copy; {{copyrightYear}} All Rights Reserved FleetOperate</span>
</div>
